








// TODO: Что бы был полноценный клмпонент, надо при сохранении возвращать координаты
import Vue from 'vue'
import Crop from "../../../components/crop";
import SettingsService from '../../settings.service'
import { Response } from '../../../ordercall'

let settingsService = new SettingsService()

function getRandom(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default Vue.extend({
    props: ['url'],
    data() {
        return {
            hash: (getRandom(0, 10000) + Date.now()).toString(),
            options: {},
            coor: {}
        }
    },
    created() {
        let onSelection = (img: any, selection: any) => {
            if (!selection.width || !selection.height) {
                let size = img.height > img.width ? img.width : img.height
                selection.height = size
                selection.width = size
            }
            let kWidth = img.naturalWidth / img.width
            let kHeight = img.naturalHeight / img.height
            
            this.coor = {
                height: selection.height * kHeight,
                width: selection.width * kWidth,
                x1: selection.x1 * kWidth,
                x2: selection.x2 * kWidth,
                y1: selection.y1 * kHeight,
                y2: selection.y2 * kHeight
            }
        }
        this.options = {
            handles: true,
            aspectRatio: '1:1',
            fadeSpeed: 200,
            zIndex: 150,
            onSelectEnd: onSelection,
            onInit: onSelection
        }
    },
    methods: {
        cropPhoto() {
            settingsService.cropPhoto(this.coor).done((res: Response) => {
                if (res.status == 'fail') {
                    return
                }
                let photo = res.data.url + '?pub' + this.hash
                this.$emit('save', photo)
                // settingsService.savePhoto(photo)
            })
        }
    },
    directives: {
        Crop
    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/form/CropPhoto.vue